<script>
import fadeInUp from '../components/animations/FadeInUp.vue';
import magnetic from '../components/Magnetic.vue';

export default {
    components: {
        fadeInUp,
        magnetic
    },

    props: ['id'],

    computed: {
        activeCheck() {
            return this.$parent.activePanel === this.id;
        }
    },

    methods: {
        makeActive() {
            if (this.activeCheck) {
                this.$parent.activePanel = null;
            } else {
                this.$parent.activePanel = this.id;
            }
        },

        beforeEnter(el) {
            el.style.height = '0';
        },

        enter(el) {
            el.style.height = el.scrollHeight + 'px';
            this.scrollTriggerRefresh();
        },

        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px';
        },

        leave(el) {
            el.style.height = '0';
            this.scrollTriggerRefresh();
        },

        scrollTriggerRefresh() {
            setTimeout(() => {
                ScrollTrigger.refresh();
            }, 300);
        }
    }
};
</script>
